/**
 * Serializes rest vial writes that read-then-write shared state (label numbers, status checks)
 * across concurrent server transactions. Released automatically on commit/rollback.
 */
export async function lockRestVials(tx) {
    if (tx.location !== 'server')
        return;
    await tx.dbTransaction.query(`SELECT pg_advisory_xact_lock(hashtext('rest_vials'))`, []);
}
//# sourceMappingURL=rest-vials.js.map